import { render } from "./FullScreenButton.vue?vue&type=template&id=0be87b6c&scoped=true"
import script from "./FullScreenButton.vue?vue&type=script&lang=js"
export * from "./FullScreenButton.vue?vue&type=script&lang=js"

import "./FullScreenButton.vue?vue&type=style&index=0&id=0be87b6c&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be87b6c"]])

export default __exports__